"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionSlotViewModel = void 0;
const ko = __importStar(require("knockout"));
const CalendarKeyEventUtility_1 = require("../../../utility/CalendarKeyEventUtility");
class SectionSlotViewModel {
    constructor(calVModel, configuration, stringsProvider) {
        this.calVModel = calVModel;
        this.configuration = configuration;
        this.stringsProvider = stringsProvider;
        this.activeSlot = ko.observable().extend({ deferred: true });
        this.renderedSlots = ko.observable([]);
    }
    getVisibleSlots() {
        return ko.computed(() => {
            let slots = [];
            let selDayIndex = this.calVModel.selectedDayIndex();
            if (selDayIndex > -1 && this.calVModel.days().length > selDayIndex) {
                const selectedDay = this.calVModel.days()[this.calVModel.selectedDayIndex()];
                if (selectedDay.isSelectable()) {
                    const slotEndIndex = selectedDay.slotsEndIndex;
                    for (let slotIndex = selectedDay.slotsStartIndex; slotIndex <= slotEndIndex; slotIndex++) {
                        slots.push(this.calVModel.slots()[slotIndex]);
                    }
                }
            }
            this.renderedSlots(slots);
            return slots;
        }, this);
    }
    getHeader() {
        let slotsHeader = this.stringsProvider.getString(this.calVModel.id + ':slot-header');
        if (!slotsHeader) {
            slotsHeader = this.stringsProvider.getString('g:slotsheader');
        }
        return ko.observable(slotsHeader);
    }
    ;
    isMultiSelectable() {
        return this.configuration.numOfSelection > 1 ? true : false;
    }
    ;
    handleSlotsBoxKeyup(destination, event) {
        const eventName = CalendarKeyEventUtility_1.CalendarKeyEventUtility.getKeyEventName(event);
        const currentSlot = this.activeSlot();
        let nextSlot;
        let direction;
        if (!currentSlot || !currentSlot.focus) {
            return false;
        }
        switch (eventName) {
            case CalendarKeyEventUtility_1.CalendarKeyEventUtility.KEY_EVENT_NAMES.ENTER:
                currentSlot.select();
                break;
            case CalendarKeyEventUtility_1.CalendarKeyEventUtility.KEY_EVENT_NAMES.UP_ARROW:
            case CalendarKeyEventUtility_1.CalendarKeyEventUtility.KEY_EVENT_NAMES.LEFT_ARROW:
                direction = ViewModelConstant.direction.Left;
                nextSlot = this.getNextSlotByDirection(currentSlot, direction);
                currentSlot.blur();
                this.activeSlot(nextSlot);
                break;
            case CalendarKeyEventUtility_1.CalendarKeyEventUtility.KEY_EVENT_NAMES.DOWN_ARROW:
            case CalendarKeyEventUtility_1.CalendarKeyEventUtility.KEY_EVENT_NAMES.RIGHT_ARROW:
                direction = ViewModelConstant.direction.Right;
                nextSlot = this.getNextSlotByDirection(currentSlot, direction);
                currentSlot.blur();
                this.activeSlot(nextSlot);
                break;
            default:
        }
        return false;
    }
    ;
    getNextSlotByDirection(currentSlot, direction) {
        const slotIndex = currentSlot.slotIndex;
        const day = this.calVModel.days()[currentSlot.dayIndex];
        let nextSlotIndex;
        if (direction === ViewModelConstant.direction.Right) {
            nextSlotIndex = slotIndex + 1;
        }
        else if (direction === ViewModelConstant.direction.Left) {
            nextSlotIndex = slotIndex - 1;
        }
        if (!(nextSlotIndex >= day.slotsStartIndex && nextSlotIndex <= day.slotsEndIndex)) {
            if (direction === ViewModelConstant.direction.Right) {
                nextSlotIndex = day.slotsStartIndex;
            }
            else if (direction === ViewModelConstant.direction.Left) {
                nextSlotIndex = day.slotsEndIndex;
            }
        }
        return this.calVModel.slots()[nextSlotIndex];
    }
}
exports.SectionSlotViewModel = SectionSlotViewModel;
